<app-spinner *ngIf="loading"></app-spinner>

<div class="top" *ngIf="!loading">
  <div class="filters" style="display: flex; justify-content: space-around">
    <md-select [(ngModel)]="termTypeSelected" style="width: 50%; padding-top: 15px"
      (change)="setFilteredBtSportProducts()">
      <md-option *ngFor="let termType of termTypes" [value]="termType">
        {{ termType }}
      </md-option>
    </md-select>
    <md-form-field style="width: 150px; padding-left: 16px">
      <input name="term" type="text" mdInput [(ngModel)]="term" placeholder="Search"
        (keyup)="setFilteredBtSportProducts()" />
    </md-form-field>
  </div>

  <div class="filters">
    <md2-datepicker [(ngModel)]="startDate" format="dd/MM/y" placeholder="Start date" (change)="startDateChanged()"
      [openOnFocus]="true"></md2-datepicker>
    <md2-datepicker [(ngModel)]="endDate" format="dd/MM/y" placeholder="End date" (change)="endDateChanged()"
      [openOnFocus]="true">
    </md2-datepicker>
  </div>

  <div class="filters">
    <md-select [(ngModel)]="sportsSelected" placeholder="Sports" style="width: 50%" [multiple]="true"
      (change)="setFilteredBtSportProducts()">
      <md-option disabled="disabled" style="margin-left: -36px; color: black">
        <md-checkbox name="selectAll" style="margin-left: 4px" color="accent" (change)="selectAllSports($event)"
          [checked]="allSportsSelected()">Select all</md-checkbox>
      </md-option>
      <md-option *ngFor="let sport of sportsSearch" [value]="sport">
        {{ sport }}
      </md-option>
    </md-select>
  </div>

  <div class="filters">
    <md-select [(ngModel)]="channelsSelected" placeholder="Channels" style="width: 50%" [multiple]="true"
      (change)="setFilteredBtSportProducts()">
      <md-option disabled="disabled" style="margin-left: -36px; color: black">
        <md-checkbox name="selectAll" style="margin-left: 4px" color="accent" (change)="selectAllChannels($event)"
          [checked]="allChannelsSelected()">Select all</md-checkbox>
      </md-option>
      <md-option *ngFor="let channel of channels" [value]="channel">
        {{ channel }}
      </md-option>
    </md-select>
  </div>

  <div class="filters">
    <md-select [(ngModel)]="statusSelected" placeholder="Status" style="width: 50%">
      <md-option *ngFor="let status of statusAvailable" (click)="
          setContribued(
            status.masterSportingEventContribued,
            status.sportingEventContribued
          )
        " [value]="status.value">
        {{ status.value }}
      </md-option>
    </md-select>
  </div>

  <div class="filters">
    <md-slide-toggle [checked]="showReplay" (change)="setShowReplay($event)"></md-slide-toggle>
    Show replay
  </div>
  <button md-raised-button type="button" (click)="searchClear()">
    <md-icon>clear</md-icon>
    Clear
  </button>
  <button md-raised-button (click)="ExtractExcel()">Extract Excel</button>
</div>
<div class="wrapper">
  <div class="table-container">
    <div class="no-results" *ngIf="
        !loading &&
        filteredBtSportProducts &&
        filteredBtSportProducts.length === 0
      ">
      <md-icon>search</md-icon>
      <h3>No results</h3>
    </div>
    <table [md2Data]="filteredBtSportProducts" *ngIf="
        !loading &&
        filteredBtSportProducts &&
        filteredBtSportProducts.length > 0
      " class="bt-sports-table" #md2="md2DataTable" [rowsPerPage]="100">
      <thead>
        <tr>
          <th md2SortBy="liveDate">Time</th>
          <th md2SortBy="sportName">Sport</th>
          <th md2SortBy="name">Title</th>
          <th md2SortBy="description">Description</th>
          <th md2SortBy="channel">Channel</th>
          <th md2SortBy="broadcastName">Broadcasting</th>
          <th md2SortBy="ageMarkName">Rating</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of md2.data" class="row cursor-pointer" (click)="setBTSportProductToEdit(row)"
          [ngClass]="{ current: row.active }">
          <td [ngClass]="{
              redalert:
                ((!row.isSportingEvent && row.labelId === -1) ||
                  (row.isSportingEvent && !row.sportingEventId)) &&
                row.dayDiff >= 0,
              orangealert:
                ((!row.isSportingEvent && row.labelId === -1) ||
                  (row.isSportingEvent && !row.sportingEventId)) &&
                row.dayDiff === -1,
              yellowalert:
                ((!row.isSportingEvent && row.labelId === -1) ||
                  (row.isSportingEvent && !row.sportingEventId)) &&
                row.dayDiff === -2
            }">
            {{ row.GetTimeString() }}
          </td>
          <td>{{ row.sportName }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.GetDescriptionShort() }}</td>
          <td>{{ row.channel }}</td>
          <td>{{ row.broadcastName }}</td>
          <td>{{ row.ageMarkName }}</td>
          <td>
            <md-icon *ngIf="
                ((!row.isSportingEvent ||
                  (row.isSportingEvent && row.sportingEventId)) &&
                  row.masterSportingEventId) ||
                (!row.isSportingEvent && row.labelId >= 0)
              ">done</md-icon>
            <span *ngIf="
                row.isSportingEvent &&
                row.masterSportingEventId &&
                !row.sportingEventId
              ">TBA</span>
            <md-icon *ngIf="
                !row.masterSportingEventId &&
                !row.sportingEventId &&
                row.labelId === -1
              ">close</md-icon>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4">
            <md2-pagination></md2-pagination>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="edit-container">
    <div class="menu-sidenav" *ngIf="btSport">
      <div class="bt-sport-details-title">
        <span>Product information</span>
      </div>
      <div class="bt-sport-details-row">
        <div>
          <span class="bt-sport-details-label">Sport: </span>
        </div>
        <div style="padding-top: 8px">
          <md-select *ngIf="sports && sports.length > 0" [(ngModel)]="btSport.chapcaSportId"
            (change)="changeSport($event)" md-tooltip="Select your sport" style="width: 50%">
            <md-option>
              <input [(ngModel)]="sportTerm" (keyup)="searchSport()" (click)="$event.stopPropagation()" type="text"
                placeholder="Search ..." mdInput /></md-option>
            <md-option *ngFor="let sport of filteredSports" [value]="sport.id">
              {{ sport.name }}
            </md-option>
          </md-select>
          <app-spinner style="padding-bottom: 20px" *ngIf="sports && sports.length === 0"></app-spinner>
        </div>
      </div>
      <div class="bt-sport-details-row">
        <div>
          <span class="bt-sport-details-label">Age mark: </span>
        </div>
        <div style="padding-top: 8px">
          <md-select *ngIf="ageMarks && ageMarks.length > 0" [(ngModel)]="btSport.ageMarkId"
            (change)="changeAgeMark($event)" md-tooltip="Select your age mark" style="width: 50%">
            <md-option *ngFor="let ageMark of ageMarks" [value]="ageMark.ageMarkTemplateId">
              {{ ageMark.name }}
            </md-option>
          </md-select>
          <app-spinner style="padding-bottom: 20px" *ngIf="ageMarks && ageMarks.length === 0"></app-spinner>
          <button *ngIf="btSport.ageMarkId && btSport.ageMarkId != -1" color="warn" md-raised-button
            (click)="unlinkAgeMark()">
            Clear
          </button>
        </div>
      </div>
      <div class="bt-sport-details-row">
        <span class="bt-sport-details-label">Live date:</span>
        <md2-datepicker [(ngModel)]="liveStartDate" type="datetime" format="dd/MM/y HH:mm" placeholder="Live date"
          class="details-datepicker" [openOnFocus]="true" (change)="changeLiveDate($event)"></md2-datepicker>
        <md2-datepicker [(ngModel)]="liveEndDate" type="datetime" format="dd/MM/y HH:mm" placeholder="Live end"
          class="details-datepicker" [openOnFocus]="true" (change)="changeLiveEnd($event)"></md2-datepicker>
        <a style="margin-left: 30px" *ngIf="possibleDatetime && possibleDatetime.isPossible" md-button
          (click)="updateLiveTimings()">
          Auto set live timings
        </a>
        <button style="margin-left: 30px" *ngIf="liveTimingChange" aria-label="Save live timing" color="accent" md-raised-button (click)="saveLiveTiming()">
          Save
        </button>
      </div>
      <div class="bt-sport-details-row">
        <span class="bt-sport-details-label">Product code:</span>
        <span> {{ btSport.btSportProductCode }}</span>
      </div>
      <div class="bt-sport-details-row">
        <span class="bt-sport-details-label">Version:</span>
        <span> {{ btSport.version }}</span>
      </div>
      <div class="bt-sport-details-row wrapper-row">
        <div>
          <span class="bt-sport-details-label">Description:</span>
          <span> {{ btSport.description }}</span>
        </div>
        <div>
          <md-icon [mdTooltip]="copyTooltip" style="cursor: pointer" (click)="copyDescription()">content_copy</md-icon>
        </div>
      </div>
      <div class="bt-sport-details-row" *ngIf="btSport.isSportingEvent">
        <div style="padding-top: 8px">
          <md-form-field style="width: 200px; padding: 16px 0px">
            <input name="manualSportingEventId" type="number" mdInput [(ngModel)]="manualSportingEventId"
              placeholder="Sporting Event Id" />
          </md-form-field>
          <button color="accent" md-raised-button (click)="applyManualSportingEventId()">
            Apply
          </button>
          <span *ngIf="manualSportingEventError">Sporting Event not found...</span>
        </div>
        <div>
          <span class="bt-sport-details-label">Master Sporting Event:</span>
        </div>
        <div style="padding-top: 8px">
          <md-select *ngIf="masterSportingEvents && masterSportingEvents.length > 0"
            [(ngModel)]="btSport.masterSportingEventId" (change)="changeMasterSportingEvent($event)"
            md-tooltip="Select your master sporting event" style="width: 95%">
            <md-option>
              <input [(ngModel)]="masterSportingEventTerm" (keyup)="searchMasterSportingEvent()"
                (click)="$event.stopPropagation()" placeholder="Search ..." type="text" mdInput /></md-option>
            <md-option *ngFor="let sportingEvent of filteredMasterSportingEvents" [value]="sportingEvent.id">
              {{ sportingEvent.name }}
            </md-option>
          </md-select>
          <md-icon *ngIf="
              btSport.masterSportingEventId &&
              btSport.masterSportingEventId > 0 &&
              masterSportingEvents &&
              masterSportingEvents.length > 0 &&
              btSport.masterSportingEventId > 0
            " md-tooltip="Erase" class="erase-sportingevent" (click)="changeMasterSportingEvent({ event: null })">
            close
          </md-icon>
          <span *ngIf="masterSportingEvents && masterSportingEvents.length === 0">No sporting events found</span>
          <app-spinner style="padding-bottom: 20px" *ngIf="!masterSportingEvents"></app-spinner>
        </div>
      </div>
      <div class="bt-sport-details-row" *ngIf="btSport.isSportingEvent && btSport.masterSportingEventId">
        <div>
          <span class="bt-sport-details-label">Sporting Event:</span>
        </div>
        <div style="padding-top: 8px">
          <md-select *ngIf="sportingEvents && sportingEvents.length > 0" [(ngModel)]="btSport.sportingEventId"
            (change)="changeSportingEvent($event)" md-tooltip="Select your sporting event" style="width: 95%">
            <md-option>
              <input [(ngModel)]="sportingEventTerm" (keyup)="searchSportingEvent()" (click)="$event.stopPropagation()"
                type="text" placeholder="Search ..." mdInput /></md-option>
            <md-option *ngFor="let sportingEvent of filteredSportingEvents" [value]="sportingEvent.sportingEventId" style="font-size:12px;">
              {{ sportingEvent.name }} ({{ sportingEvent.sportingEventId }})
            </md-option>
          </md-select>
          <md-icon *ngIf="
              btSport.sportingEventId &&
              btSport.sportingEventId > 0 &&
              sportingEvents &&
              sportingEvents.length > 0
            " class="erase-sportingevent" md-tooltip="Erase" (click)="changeSportingEvent({ event: null })">
            close
          </md-icon>
          <span *ngIf="sportingEvents && sportingEvents.length === 0">No sporting events found</span>
          <app-spinner style="padding-bottom: 20px" *ngIf="!sportingEvents"></app-spinner>
        </div>
      </div>
      <div class="bt-sport-details-row" *ngIf="!btSport.isSportingEvent">
        <div>
          <span class="bt-sport-details-label">Type:</span>
        </div>
        <div style="padding-top: 8px">
          <md-select *ngIf="types && types.length > 0" [(ngModel)]="btSport.typeId" (change)="changeType($event)"
            md-tooltip="Select type" style="width: 95%">
            <md-option>
              <input [(ngModel)]="typeTerm" (keyup)="searchType()" (click)="$event.stopPropagation()"
                placeholder="Search ..." type="text" mdInput /></md-option>
            <md-option *ngFor="let type of filteredTypes" [value]="type.id">
              {{ type.name }}
            </md-option>
          </md-select>
          <app-spinner style="padding-bottom: 20px" *ngIf="!types"></app-spinner>
        </div>
      </div>
      <div class="bt-sport-details-row" *ngIf="!btSport.isSportingEvent && btSport.typeId >= 0">
        <div>
          <span class="bt-sport-details-label">Group:</span>
        </div>
        <div style="padding-top: 8px">
          <md-select *ngIf="groups && groups.length > 0" [(ngModel)]="btSport.groupId" (change)="changeGroup($event)"
            md-tooltip="Select type" style="width: 95%">
            <md-option>
              <input [(ngModel)]="groupTerm" (keyup)="searchGroup()" (click)="$event.stopPropagation()"
                placeholder="Search ..." type="text" mdInput /></md-option>
            <md-option *ngFor="let group of filteredGroups" [value]="group.id">
              {{ group.name }}
            </md-option>
          </md-select>
          <app-spinner style="padding-bottom: 20px" *ngIf="!groups"></app-spinner>
        </div>
      </div>
      <div class="bt-sport-details-row" *ngIf="!btSport.isSportingEvent && btSport.groupId >= 0">
        <div>
          <span class="bt-sport-details-label">Label:</span>
        </div>
        <div style="padding-top: 8px">
          <md-select *ngIf="labels && labels.length > 0" [(ngModel)]="btSport.labelId" (change)="changeLabel($event)"
            md-tooltip="Select label" style="width: 95%">
            <md-option>
              <input [(ngModel)]="labelTerm" (keyup)="searchLabel()" (click)="$event.stopPropagation()"
                placeholder="Search ..." type="text" mdInput /></md-option>
            <md-option *ngFor="let label of filteredLabels" [value]="label.id">
              {{ label.name }}
            </md-option>
          </md-select>
          <app-spinner style="padding-bottom: 20px" *ngIf="!labels"></app-spinner>
        </div>
      </div>
      <div class="bt-sport-details-row">
        <md-checkbox name="isSportingEvent" style="margin-left: 4px" color="accent"
          (change)="changeIsSportingEvent($event)" [checked]="btSport.isSportingEvent">Is a Sporting Event</md-checkbox>
      </div>
      <div class="bt-sport-details-button">
        <button md-raised-button (click)="seeEmissions()">See emissions</button>
        <button md-raised-button *ngIf="!btSport.isSportingEvent && btSport.labelId >= 0" (click)="resetNonSport()">
          Clear
        </button>
      </div>
      <div class="bt-sport-details-updating" *ngIf="updating">
        <span>Updating...</span>
        <app-spinner style="padding-bottom: 20px"></app-spinner>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/pages/bt-sport/bt-sport.component.html